document.addEventListener("DOMContentLoaded", () => {
	const sections = document.querySelectorAll(".pf-feature-steps");

	const observer = new IntersectionObserver(
		(entries, obs) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;

				const steps = entry.target.querySelectorAll(".animate-fade-up");

				steps.forEach((step) => {
					step.classList.add("is-visible");
				});

				obs.unobserve(entry.target);
			});
		},
		{
			threshold: 0.25,
		},
	);

	sections.forEach((section) => observer.observe(section));
});